export type WithClient<T extends { client?: unknown }> = T & { client: NonNullable<T["client"]> };

/** `client` is null when the referenced client no longer exists or is outside the caller's scope. */
export function hasClient<T extends { client?: unknown }>(item: T): item is WithClient<T> {
  return item.client != null;
}
